<app-page-header title="2024. évi általános választások"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <a
    href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Kozlememy-a-valasztasi-kerelmek-benyujtasarol-20231205.pdf"
    target="_blank"
    >Változik a névjegyzéki kérelmek ügyintézése</a
  ><br /><br />
  <ul>
    <li>
      <a
        href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Nemzetisegi-nevjegyzeki-kerelem.pdf"
        target="_blank"
        >Nemzetiségi névjegyzéki kérelem</a
      >
    </li>
    <li>
      <a
        href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Segitseg-igenylese-a-valasztojog-gyakorlasahoz-1.pdf"
        target="_blank"
        >Segítség igénylése a választójog gyakorlásához</a
      >
    </li>
    <li>
      <a
        href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Szemelyes-adatok-kiadasanak-tiltasa-1.pdf"
        target="_blank"
        >Személyes adatok kiadásának tiltása</a
      >
    </li>
    <li>
      <a
        href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Nevjegyzekbe-vetel-torles-iranti-kerelem-2024_eu-allampolgar.pdf"
        target="_blank"
        >Névjegyzékbe vétel-törlés iránti kérelem 2024 eu állampolgár</a
      >
    </li>
    <li>
      <a
        href="https://neszmely.hu/assets/dokumentumok/valasztas/2023/Nevjegyzekbe-vetel_modositas_torles_hosszabbitas_torles.pdf"
        target="_blank"
        >Névjegyzékbe vétel, módosítás, hosszabbítás, törlés</a
      >
    </li>
  </ul>
  <br /><br /><br /><br />
  <p>Hirdetmények</p>
  <br /><br />
  <ul>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/Hirdetmény - Szavatszámláló biz. tagjai 1.docx"
        target="_blank"
      >
        Hirdetmény - Szavatszámláló biz. tagjai 1
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/Közlemény eredményről 2024.06.12_Dunaszentmiklós.doc"
        target="_blank"
      >
        Közlemény a helyi önkormányzati képviselők és polgármesterek 2024. évi
        általános választásának dunaszentmiklósi eredményéről
      </a>
    </li>
  </ul>
  <br /><br />
  <p>HVB Határozatok</p>
  <br /><br />
  <ul>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/3-2024.(V.3.) HVB határozat Béger Ákos Imre polgármesterjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        3-2024.(V.3.) HVB határozat Béger Ákos Imre polgármesterjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/4-2024.(V.3.) HVB határozat Lengyel Zsolt polgármesterjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        4-2024.(V.3.) HVB határozat Lengyel Zsolt polgármesterjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/5-2024.(V.3.) HVB határozat Pesti Viktória képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        5-2024.(V.3.) HVB határozat Pesti Viktória képviselőjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/6-2024.(V.3.) HVB határozat Búzer Norbert képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        6-2024.(V.3.) HVB határozat Búzer Norbert képviselőjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/7-2024.(V.3.) HVB határozat Keil Richárd képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        7-2024.(V.3.) HVB határozat Keil Richárd képviselőjelölt nyilvántartásba
        vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/8-2024.(V.3.) HVB határozat Aubéli Mónika német települési nemzetiségi képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        8-2024.(V.3.) HVB határozat Aubéli Mónika német települési nemzetiségi
        képviselőjelölt nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/9-2024.(V.3.) HVB határozat Emmer Edina német települési nemzetiségi képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        9-2024.(V.3.) HVB határozat Emmer Edina német települési nemzetiségi
        képviselőjelölt nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/10-2024.(V.3.) HVB határozat Hartmann Károlyné német települési nemzetiségi képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        10-2024.(V.3.) HVB határozat Hartmann Károlyné német települési
        nemzetiségi képviselőjelölt nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/11-2024.(V.3.) HVB határozat Ströcker Ignácné német települési nemzetiségi képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        11-2024.(V.3.) HVB határozat Ströcker Ignácné német települési
        nemzetiségi képviselőjelölt nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/12-2024.(V.3.) HVB határozat Székelyi Balázs Zoltán német települési nemzetiségi képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        12-2024.(V.3.) HVB határozat Székelyi Balázs Zoltán német települési
        nemzetiségi képviselőjelölt nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/13-2024.(V.6.) HVB határozat Hartmannn Ádám képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        13-2024.(V.6.) HVB határozat Hartmannn Ádám képviselőjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/14-2024.(V.6.) HVB határozat Horváth Zoltán Zsolt képviselőjelölt nyilvántartásba vétele.pdf"
        target="_blank"
      >
        14-2024.(V.6.) HVB határozat Horváth Zoltán Zsolt képviselőjelölt
        nyilvántartásba vétele
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/16-2024.(V.6.) HVB határozat helyi önkormányzati polgármesterjelöltek szavazólapon lévő sorrendjéről.pdf"
        target="_blank"
      >
        16-2024.(V.6.) HVB határozat helyi önkormányzati polgármesterjelöltek
        szavazólapon lévő sorrendjéről
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/17-2024.(V.6.) HVB határozat önkormányzati képviselőjelöltek szavazólapon lévő sorrendjéről.pdf"
        target="_blank"
      >
        17-2024.(V.6.) HVB határozat önkormányzati képviselőjelöltek
        szavazólapon lévő sorrendjéről
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/18-2024.(V.6.) HVB határozat német települési önkormányzati képviselőjelöltek szavazólapon történő sorrendjéről.pdf"
        target="_blank"
      >
        18-2024.(V.6.) HVB határozat német települési önkormányzati
        képviselőjelöltek szavazólapon történő sorrendjéről.pdf
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/20-2024.(V.14.) HVB határozat a polgármester választás szavazólapjának jóváhagyásáról.pdf"
        target="_blank"
      >
        20-2024.(V.14.) HVB határozat a polgármester választás szavazólapjának
        jóváhagyásáról
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/21-2024.(V.14.) HVB határozat az önkormányzati képviselőjelöltek szavazólapjának jóváhagyásáról"
        target="_blank"
      >
        21-2024.(V.14.) HVB határozat az önkormányzati képviselőjelöltek
        szavazólapjának jóváhagyásáról
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/22-2024.(V.14.) HVB határozat a német települési nemzetiségi önkormányzati képviselőválasztás szavazólapjának jóváhagyásáról (1).pdf"
        target="_blank"
      >
        22-2024.(V.14.) HVB határozat a német települési nemzetiségi
        önkormányzati képviselőválasztás szavazólapjának jóváhagyásáról
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/23-2024.(VI.9.) HVB határozat a polgármester választás eredményéről.pdf"
        target="_blank"
      >
        23-2024.(VI.9.) HVB határozat a polgármester választás eredményéről
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/24-2024.(VI.9.) HVB határozat az egyéni listás képviselő választás eredményéről.pdf"
        target="_blank"
      >
        24-2024.(VI.9.) HVB határozat az egyéni listás képviselő választás
        eredményéről
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/06/25-2024.(VI.9.) HVB határozat a német települési nemzetiségi önkormányzati képviselők választása eredményéről.pdf"
        target="_blank"
      >
        25-2024.(VI.9.) HVB határozat a német települési nemzetiségi
        önkormányzati képviselők választása eredményéről
      </a>
    </li>
  </ul>
  <br /><br />
  <p>HVB Jegyzőkönyvek</p>
  <br /><br />
  <ul>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/Jegyzőkönyv HVB ülés V. 3..pdf"
        target="_blank"
      >
        Jegyzőkönyv HVB ülés V. 3.
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/Jegyzőkönyv HVB ülés V. 6..pdf"
        target="_blank"
      >
        Jegyzőkönyv HVB ülés V. 6.
      </a>
    </li>
    <li>
      <a
        href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/Jegyzőkönyv HVB ülés V. 14..pdf"
        target="_blank"
      >
        Jegyzőkönyv HVB ülés V. 14.
      </a>
    </li>
  </ul>
  <br /><br />
  <a
    href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/Meghívó a Helyi Választási Bizottság 2024. május 3-i ülésére.pdf"
    target="_blank"
    >Meghívó a Helyi Választási Bizottság 2024. május 3-i ülésére</a
  ><br />
  <a
    href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/Meghívó a Helyi Választási Bizottság 2024. május 6-i ülésére.pdf"
    target="_blank"
    >Meghívó a Helyi Választási Bizottság 2024. május 6-i ülésére</a
  ><br />
  <a
    href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/05/Meghívó a Helyi Választási Bizottság 2024. májurs 14-i ülésére.pdf"
    target="_blank"
    >Meghívó a Helyi Választási Bizottság 2024. májurs 14-i ülésére</a
  ><br />
</div>
